<div
	class="primary-bg white-text p-m"
	fxLayoutGap="2%"
	fxLayout="row"
	fxLayout.lt-sm="column"
	fxLayoutAlign="space-between center"
	fxLayoutAlign.lt-sm="space-between start"
>
	<div i18n="@@shared_notificationBanner_fundraiserPageLooksNice">
		Great! your fundraiser page looks nice
	</div>
	<button
		id="publish-button"
		mat-flat-button
		color="accent"
		[disabled]="this.isSave">
		<div
			fxLayout="row"
			fxLayoutAlign="centre center">
			<span
				i18n="@@shared_notificationBanner_publish_button"
				(click)="emitPublishClick()"
				ngClass.lt-sm="m-r-xl m-l-xl">Publish</span>
			<mat-icon *ngIf="isLoad" class="m-l-xs m-t-xs">
				<mat-spinner color="primary" diameter="16"> </mat-spinner>
			</mat-icon>
		</div>
	</button>
</div>
